const content = {
  heading: "Gamla Uppsala Kyrka",
  paragraphs: [
    "Vigseln kommer att hållas kl. 14:30 i Gamla Uppsala kyrka utanför de ikoniska Uppsala Högar. Du hittar lättast hit genom att åka norrut på Vattholmavägen från Uppsala city.",
    "Parkering finns i anslutning till kyrkan.",
  ],
};

export default content;
